import { MinusCircle } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const MinusCircleIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <MinusCircle width={size} height={size} color={color} {...rest} />;

MinusCircleIcon.displayName = 'MinusCircleIcon';

export default MinusCircleIcon;
